import logger from '../../log';
import { NonStdPlayerEvents } from '../../common/Reporter/constants';
import { dispatchPlayerEvent } from '../../events/dispatch';
import { CleanupMethod } from '../BaseInteraction';
import { HLSEventCallback } from '@kollective-frontend/ksdk-api';
const log = logger.getLogger(__filename);

export const HLS_LEVEL_SWITCHING = 'hlsLevelSwitching';
export const HLS_LEVEL_LOADED = 'hlsLevelLoaded';
export const HLS_MANIFEST_LOADED = 'hlsManifestLoaded';

export interface HlsLevelSwitchingData {
  bitrate: number;
}

type HlsEventHandler = (e: string, item: unknown) => void;

export interface HLSjsEventListenerObject {
  on: (name: string, handler: HLSEventCallback) => void;
  off: (name: string, handler?: HLSEventCallback) => void;
  once: (name: string, handler: HLSEventCallback) => void;
}
interface HlsLevelLoadedEvent {
  details: HlsLevelSwitchingData;
  level: number;
}
interface HlsManifestLoadedEvent {
  levels: HlsLevelSwitchingData[];
  firstLevel: number;
}

const attachHlsEvents = (hls: HLSjsEventListenerObject): CleanupMethod => {
  if (typeof hls.on !== 'function') {
    log.warn('Unable to set up HLS event handlers. Missing "on" function');
    return () => undefined;
  }
  const e = NonStdPlayerEvents.playbackbitratechanged.code;
  let levels: HlsLevelSwitchingData[] = [];
  const handlers: Map<string, HlsEventHandler> = new Map();
  // First argument is always the event name, which we already know because of how we've added listeners.
  handlers.set(HLS_LEVEL_SWITCHING, (_: string, evt: unknown) => {
    const item = evt as HlsLevelSwitchingData;
    dispatchPlayerEvent({ e, b: item.bitrate });
  });
  handlers.set(HLS_MANIFEST_LOADED, (_: string, evt: unknown) => {
    const item = evt as HlsManifestLoadedEvent;
    levels = [...item.levels];
  });
  handlers.set(HLS_LEVEL_LOADED, (_: string, evt: unknown) => {
    const { level } = evt as HlsLevelLoadedEvent;
    if (level < levels.length) {
      dispatchPlayerEvent({ e, b: levels[level].bitrate });
    }
  });
  handlers.forEach((handler, name) => {
    hls.on(name, handler);
  });
  return () => {
    if (hls.off) {
      handlers.forEach((handler, name) => {
        hls.off(name, handler);
      });
    }
    handlers.clear();
  };
};

export default attachHlsEvents;
